import * as React from "react";

export const ProcessesIcon = ({ props }: any) => {
  return (
    <svg width={31} height={31} viewBox="0 0 31 31" fill="none" {...props}>
      <rect width={31} height={31} rx={8} fill="#fff" />
      <rect
        x={0.5}
        y={0.5}
        width={30}
        height={30}
        rx={7.5}
        stroke="#4C5CFB"
        strokeOpacity={0.1}
      />
      <path
        d="M15.334 17.333a2 2 0 100-4 2 2 0 000 4z"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.267 17.333a1.1 1.1 0 00.22 1.214l.04.04a1.333 1.333 0 11-1.887 1.886l-.04-.04a1.1 1.1 0 00-1.213-.22 1.1 1.1 0 00-.667 1.007v.113a1.333 1.333 0 11-2.667 0v-.06a1.1 1.1 0 00-.72-1.006 1.1 1.1 0 00-1.213.22l-.04.04a1.335 1.335 0 11-1.887-1.887l.04-.04a1.1 1.1 0 00.22-1.213 1.1 1.1 0 00-1.006-.667h-.114a1.334 1.334 0 010-2.667h.06a1.1 1.1 0 001.007-.72 1.1 1.1 0 00-.22-1.213l-.04-.04a1.333 1.333 0 111.887-1.887l.04.04a1.1 1.1 0 001.213.22h.053A1.1 1.1 0 0014 9.447v-.114a1.334 1.334 0 012.667 0v.06a1.1 1.1 0 00.666 1.007 1.1 1.1 0 001.214-.22l.04-.04a1.332 1.332 0 012.176.433 1.334 1.334 0 01-.29 1.454l-.04.04a1.1 1.1 0 00-.22 1.213v.053A1.1 1.1 0 0021.22 14h.113a1.333 1.333 0 110 2.667h-.06a1.1 1.1 0 00-1.006.666v0z"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
